import { ChartData, ChartOptions } from 'chart.js';

export interface ILabels {
  brand: string;
  customer: string;
  customer_plural: string;
  quoted: string;
  reservation: string;
  reservation_plural: string;
}

export const DEFAULT_PLOT_OPTIONS: ChartOptions<'line'> = {
  plugins: { legend: { display: true } },
  responsive: true,
  maintainAspectRatio: false,
  elements: {
    line: {
      tension: 0,
      fill: false,
    },
  },
  scales: {
    'y-axis-0': {
      type: 'linear',
      display: true,
      position: 'left',
      grid: {
        drawOnChartArea: false,
        borderColor: 'gray',
        color: 'gray',
      },
      title: {
        display: true,
        text: 'Minutes',
      },
    },
    'y-axis-1': {
      type: 'linear',
      display: false,
      position: 'right',
      grid: {
        drawOnChartArea: false,
        borderColor: 'gray',
      },
      title: {
        display: false,
        text: '',
      },
    },
  },
};

export const DEFAULT_PLOT_DATA: ChartData<'line', number[], string> = {
  datasets: [
    {
      data: [0, 0, 0, 0, 0, 0, 0, 0],
      label: 'Avg Wait Time',
      yAxisID: 'y-axis-0',
      backgroundColor: '#0EAD69',
      borderColor: '#0EAD69',
      pointBackgroundColor: '#0EAD69',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#0EAD69',
    },
    {
      data: [0, 0, 0, 0, 0, 0, 0, 0],
      label: 'Avg Time from Notification to Being Served',
      yAxisID: 'y-axis-1',
      backgroundColor: '#55C2FF',
      borderColor: '#55C2FF',
      pointBackgroundColor: '#55C2FF',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: '#55C2FF',
    },
  ],
  labels: ['-13 weeks', '-12', '-11', '-10', '-9', '-8', '-7', '-6', '-5', '-4', '-3', '-2', 'Past week'],
};
